import React from 'react';

import { Box, Typography } from '@mui/material';
import StatusIconCDS from '@sharedCR/coreDesignSystem/StatusIconCDS';

import { StatusEnum } from 'constants/status';

import { SAMPLE_DATA_NOTICE } from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';

import { noticeIconStyles, noticeStyles, noticeTextStyles } from './SampleDataNotice.styles';

/** Says, above a preview, that its values are placeholders: it is not a real loan's form. */
const SampleDataNotice = () => (
  <Box data-testid={FormChangeHistoryTestIds.SAMPLE_DATA_NOTICE} sx={noticeStyles}>
    <Box sx={noticeIconStyles}>
      <StatusIconCDS type={StatusEnum.INFO} />
    </Box>
    <Typography sx={noticeTextStyles} variant="regular14">
      {SAMPLE_DATA_NOTICE}
    </Typography>
  </Box>
);

export default SampleDataNotice;
